export const TroubleshootingStepEnum = {
  NO_ERROR: 'NO_ERROR',
  MUTUAL_CHECKS: 'MUTUAL_CHECKS',
  UPDATING_SETTINGS: 'UPDATING_SETTINGS',
  RESOLVED_ROAMING_SWITCH_BLOCK: 'RESOLVED_ROAMING_SWITCH_BLOCK',
  REFRESH_SETTINGS_CONFIRMATION: 'REFRESH_SETTINGS_CONFIRMATION',
  RESTART_DEVICE: 'RESTART_DEVICE',
  IS_SUBSCRIBER_IN_JORDAN_OR_EGYPT: 'IS_SUBSCRIBER_IN_JORDAN_OR_EGYPT',
};

